function showfaqs() {
	var faqs = document.getElementById('faqs');
  faqs.style.display = "flex";
  faqs.classList.toggle("faqs-active");
  faqs.style.transform = "none";
}

function topFunction() {
  document.body.scrollTop = 0 + 640; // For Safari
  document.documentElement.scrollTop = 0 + 640 ; // For Chrome, Firefox, IE and Opera
}

const accItems = document.querySelectorAll(".accordion__item");

accItems.forEach((acc) => acc.addEventListener("click", toggleAcc));

function toggleAcc() {
  accItems.forEach((item) => item != this ? item.classList.remove("accordion__item--active") : null
  );

  if (this.classList != "accordion__item--active") {
    this.classList.toggle("accordion__item--active");
  }
}

var accordion = (function(){
  
  var $accordion = $('.accordion');
  var $accordion_header = $accordion.find('.accordion__btn');
  var $accordion_item = $('.accordion__item');
 
  // default settings 
  var settings = {
    // animation speed
    speed: 400,
    
    // close all other accordion items if true
    oneOpen: false
  };
    
  return {
    // pass configurable object literal
    init: function($settings) {
      $accordion_header.on('click', function() {
        accordion.toggle($(this));
        
        setTimeout(() => {
          $('body, html').animate({
            scrollTop: $(this).offset().top - 78
           }, 500)
        }, 400)
      });
      
      $.extend(settings, $settings); 
      
      // ensure only one accordion is active if oneOpen is true
      if(settings.oneOpen && $('.accordion__item--active').length > 1) {
        $('.accordion__item.active:not(:first)').removeClass('active');
      }
      
      // reveal the active accordion bodies
      $('.accordion__item--active').find('> .accordion__content').show();
    },
    toggle: function($this) {
            
      if(settings.oneOpen && $this[0] != $this.closest('.accordion').find('> .accordion__item--active > .accordion__btn')[0]) {
        $this.closest('.accordion')
               .find('> .accordion__item') 
               .removeClass('active')
               .find('.accordion__content')
               .slideUp()
      }
      
      // show/hide the clicked accordion item
      $this.closest('.accordion__item').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  }
})();

$(document).ready(function(){
  accordion.init({ speed: 300, oneOpen: true });
});